const driverLogHu = {
	driverLogTable: 'Driver log',
	driverLogEditForm: 'Driver Log',
	name: 'Name',
	tableName: 'Table Name',
	description: 'Description'
};

export default driverLogHu;
